// src/MensagensEnviadas.js
import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, query, where, getDocs, orderBy } from 'firebase/firestore';
import { Typography, Box, CircularProgress, Link, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function MensagensEnviadas({ user }) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      if (!user) return;
      
      try {
        // AQUI ESTÁ A DIFERENÇA: Buscamos pelo 'remetenteId'
        const q = query(
          collection(db, "mensagens"),
          where("remetenteId", "==", user.uid),
          orderBy("dataEnvio", "desc")
        );

        const querySnapshot = await getDocs(q);
        
        // Precisamos buscar os nomes dos destinatários para exibir algo melhor que IDs
        // Para simplificar e evitar excesso de leituras, vamos exibir a quantidade de destinatários
        // ou, se forem poucos, tentar resolver os nomes seria uma otimização futura.
        
        setMessages(querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          dataEnvio: doc.data().dataEnvio.toDate() 
        })));
      } catch (error) {
        console.error("Erro ao buscar mensagens enviadas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [user]);

  if (loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}><CircularProgress /></Box>;
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Histórico de Mensagens Enviadas</Typography>
      {messages.length === 0 ? (
        <Typography>Você ainda não enviou nenhuma mensagem.</Typography>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {messages.map(msg => (
            <Accordion key={msg.id}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="subtitle2">
                        {msg.dataEnvio.toLocaleString('pt-BR')}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        Enviado para: {msg.destinatarios.length} destinatário(s)
                    </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1" sx={{ mb: 2, whiteSpace: 'pre-wrap' }}>{msg.mensagemTexto}</Typography>
                
                {msg.imagemUrl && (
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="caption" display="block">Anexo:</Typography>
                    <Link href={msg.imagemUrl} target="_blank" rel="noopener noreferrer">
                        Ver Arquivo/Imagem
                    </Link>
                  </Box>
                )}
                
                <Box sx={{ mt: 2 }}>
                    <Typography variant="caption">ID da Mensagem: {msg.id}</Typography>
                </Box>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      )}
    </Box>
  );
}

export default MensagensEnviadas;